import React, { Component, useState } from "react";
import { render } from "react-dom";
import ConcListD from "./MenuDesktop";
import ConcList from "./MenuMobile";
import { useMediaQuery } from 'react-responsive'


export default function AdminHomeResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <ConcListD/>}
        {isMobileDevice && <ConcList/>}  
      </div>
    )
}

